import React from 'react';

import { ResponsivePaymentsTable } from './PaymentsOverviewTable.component';
import { processingPaymentsDesktopColumns } from './PaymentsOverviewTable.declaration-desktop';
import { paymentsOverviewMobileColumns } from './PaymentsOverviewTable.declaration-mobile';
import { Box, Typography } from '@mui/material';
import { PatientServiceItem } from '@uplift/api';


export const ProcessingPaymentsTable: React.VFC<{
  items: PatientServiceItem[];
}> = ({ items: pendingServiceItems }) => {
  if (!pendingServiceItems.length) {
    return null;
  }

  return (
    <Box display="flex" flexDirection="column" gap="8px">
      <Box px={{ xs: 2, sm: 0 }}>
        <Typography variant="h4">Processing ({pendingServiceItems.length})</Typography>
      </Box>
      <ResponsivePaymentsTable
        columns={{
          desktop: processingPaymentsDesktopColumns,
          mobile: paymentsOverviewMobileColumns,
        }}
        rows={pendingServiceItems}
      />
    </Box>
  );
};
